var MultipleMaterials = (function () {
    function MultipleMaterials() {
    }
    return MultipleMaterials;
}());
export { MultipleMaterials };
